// Тексты с числом (FR-036в): число согласуется с существительным, глагол — с числом;
// тексты не зависят от рода человека (FR-036а).
import { formatCount, plural } from '@kp/contracts';
import type { PluralForms } from '@kp/contracts';

/** Глагол в единственном и множественном числе: «Завершится» / «Завершатся». */
export type VerbForms = readonly [singular: string, plural: string];

/**
 * «Завершится 1 сеанс», «Завершатся 2 сеанса», «Завершатся 5 сеансов», «Завершится 21 сеанс».
 * При N = 0 строки нет (contracts/ui.md, «Действия и подтверждения»).
 */
export function countPhrase(n: number, verb: VerbForms, noun: PluralForms): string | null {
  if (n === 0) return null;
  const verbForm = plural(n, [verb[0], verb[1], verb[1]]);
  return `${verbForm} ${formatCount(n, noun)}`;
}

/** Части текста через запятую, пустые пропускаются; первая буква — заглавная. */
export function joinPhrases(parts: readonly (string | null | undefined)[]): string {
  const text = parts.filter((part): part is string => Boolean(part)).join(', ');
  return text ? text.charAt(0).toLocaleUpperCase('ru-RU') + text.slice(1) : '';
}
